export default __webpack_public_path__ + "media/images/image-1-82dec2d1840937506c77ba30c06f7fc7.jpg";